// src/Analytics.jsx
import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-F234D6YK4X'); // Yahan aapka actual GA4 Measurement ID dalein
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};
